export default function Row(props) {
  const { tag, onClick, style, className } = props;

  const Tag = tag || "article";

  return (
    <Tag
      style={style}
      className={`${className ?? ""} element _row`}
      onClick={onClick ? onClick : undefined}
    >
      {props.children}
    </Tag>
  );
}
